import { WaitForEventStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { supportedWaitForEventTypes } from "@redotech/redo-model/advanced-flow/common";
import { FrontendStepType, PartialWithRequiredType } from ".";
import { getPrettyEventName } from "../utils/event-utils";

export const validateWaitForEventStep = (
  step: PartialWithRequiredType<WaitForEventStep>,
) => {
  return !!step.eventType;
};

export const waitForEventStepType: FrontendStepType<
  PartialWithRequiredType<WaitForEventStep>
> = {
  valid: validateWaitForEventStep,
  type: "standard",
  inspectorFactory: (props) => ({
    header: { title: "Wait for event" },
    sections: [
      {
        fields: [
          {
            path: "eventType",
            label: "Event Type",
            widget: "select",
            disabledIf: () => true, //We are temporarily only supporting one event type
            options: supportedWaitForEventTypes.map((type) => {
              return { name: type, displayName: getPrettyEventName(type) };
            }),
          },
        ],
      },
    ],
  }),
};
